<template>
  <div class="header-nav">
    <div class="container nav">
      <div class="app-logo">
        <img
          @click="$router.push('/')"
          src="@/assets/logo/logo-FIT2CLOUD.png"
          height="20"
          alt=""
        />
      </div>
      <nav class="primary-nav">
        <ul>
          <li @click="$router.push('/')">
            <a> 首页</a>
          </li>

          <li>
            <el-dropdown placement="bottom" trigger="hover">
              <span style="color:#191818; font-size: 15px">
                开源产品<i class="icon el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="home-dropdown">
                <!-- 二级菜单 -->
                <div class="sub-nav">
                  <ul class="submenu new-submenu">
                    <li v-for="(item, index) in subNav" :key="index">
                      <a @click="toProduct(item)" target="_blank">
                        <div class="submenu-item">
                          <div
                            class="border rounded mr-3 text-center icon"
                            style="padding: 10px"
                          >
                            <img
                              :src="getImg(item.productId)"
                              class="l-dark"
                              width="20"
                              alt=""
                            />
                          </div>
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; font-weight: 500; margin: 0"
                            >
                              <b>{{ item.name }}</b>
                            </p>
                            <p class="subName">{{ item.productTitle }}</p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li>
            <el-dropdown placement="bottom" trigger="hover">
              <span style="color:#191818; font-size: 15px">
                一体机<i class="icon el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="home-dropdown">
                <!-- 二级菜单 -->
                <div class="sub-nav">
                  <ul class="submenu new-submenu">
                    <li>
                      <a
                        href="https://1panel.cn/ai-appliance.html"
                        target="_blank"
                      >
                        <div class="submenu-item">
                          <div
                            class="border rounded mr-3 text-center icon"
                            style="padding: 10px"
                          >
                            <img
                              src="@/assets/logo/1panel.png"
                              class="l-dark"
                              width="20"
                              alt=""
                            />
                          </div>
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; font-weight: 500; margin: 0"
                            >
                              1Panel AI 一体机
                            </p>
                          </div>
                          <span class="new-badge">NEW</span>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="https://maxkb.cn/appliance" target="_blank">
                        <div class="submenu-item">
                          <div
                            class="border rounded mr-3 text-center icon"
                            style="padding: 9px 8px"
                          >
                            <img
                              src="@/assets/logo/maxkb.png"
                              class="l-dark"
                              width="24"
                              alt=""
                            />
                          </div>
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; font-weight: 500; margin: 0"
                            >
                              MaxKB AI 一体机
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://jumpserver.org/hardware.html"
                        target="_blank"
                      >
                        <div class="submenu-item">
                          <div
                            class="border rounded mr-3 text-center icon"
                            style="padding: 9px 8px"
                          >
                            <img
                              src="@/assets/logo/jumpserver.png"
                              class="l-dark"
                              width="24"
                              alt=""
                            />
                          </div>
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; font-weight: 500; margin: 0"
                            >
                              JumpServer 一体机
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.fit2cloud.com/zabbix/index.html"
                        target="_blank"
                      >
                        <div class="submenu-item">
                          <div
                            class="border rounded mr-3 text-center icon"
                            style="padding: 10px"
                          >
                            <img
                              src="@/assets/logo/zabbix.png"
                              class="l-dark"
                              width="20"
                              alt=""
                            />
                          </div>
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; font-weight: 500; margin: 0"
                            >
                              Zabbix 信创一体机
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li>
            <el-dropdown placement="bottom" trigger="hover">
              <span style="color:#191818; font-size: 15px">
                帮助与支持<i class="icon el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="home-dropdown">
                <!-- 二级菜单 -->
                <div class="sub-nav" style="min-width: 120px;">
                  <ul class="submenu new-submenu">
                    <li>
                      <a href="https://docs.fit2cloud.com/" target="_blank">
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; margin: 0"
                            >
                              文档中心
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="https://bbs.fit2cloud.com/" target="_blank">
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; margin: 0"
                            >
                              社区论坛
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="https://kb.fit2cloud.com/" target="_blank">
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; margin: 0"
                            >
                              知识库
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="https://blog.fit2cloud.com/" target="_blank">
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px;  margin: 0"
                            >
                              技术博客
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="https://edu.fit2cloud.com" target="_blank">
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px; margin: 0"
                            >
                              培训认证
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://space.bilibili.com/510493147"
                        target="_blank"
                      >
                        <div class="submenu-item">
                          <div class="">
                            <p
                              style="color: #212529; font-size: 15px;  margin: 0"
                            >
                              观看直播
                            </p>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- <li>
            <a href="/bi" target="_blank"> 开源大屏</a>
          </li> -->

          <li>
            <a href="https://store.fit2cloud.com/shop/products" target="_blank">
              周边商城</a
            >
          </li>

          <li>
            <div v-if="isAuthenticated">
              <el-dropdown trigger="hover">
                <el-button
                  type="primary"
                  icon="el-icon-user"
                  circle
                ></el-button>
                <el-dropdown-menu slot="dropdown" class="user-dropdown">
                  <el-dropdown-item @click.native="$router.push('/account')">
                    个人中心
                  </el-dropdown-item>
                  <el-dropdown-item divided @click.native="logout">
                    退出
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div v-if="!isAuthenticated">
              <el-button type="primary" size="medium" @click="login"
                >登录</el-button
              >
              <!-- <p class="register">没有账户？<a @click="register">立即创建</a></p> -->
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import { listSubNavs } from "@/api/navs";
export default {
  name: "AppNav",
  components: {},
  data() {
    return {
      subNavActive: "",
      subNav: [],
      refresh: false,
      subnavShow: true
    };
  },
  computed: {
    ...mapGetters(["activeTab"]),
    subNavChild() {
      const attr = this.subNav.filter(
        item => this.subNavActive === item.productId
      );
      return attr[0]?.tabs || [];
    },
    isAuthenticated() {
      return Vue.$keycloak.authenticated;
    }
    // name() {
    //   return Vue.$keycloak.tokenParsed.name;
    // },
  },
  watch: {
    subNav: {
      immediate: true,
      handler: function(newValue) {
        if (newValue.length === 0) {
          this.getSubNav();
        }
      }
    }
  },
  created() {},
  methods: {
    toProduct(item) {
      this.$router.push(`/products/${item.productId}/information`);
    },
    getImg(name) {
      return name ? require(`@/assets/logo/${name}.png`) : "";
    },
    // 登录
    login() {
      Vue.$keycloak.login();
    },
    logout() {
      Vue.$keycloak.logout();
    },
    register() {
      Vue.$keycloak.register();
    },
    getSubNav() {
      listSubNavs()
        .then(response => {
          if (response && response.length > 0) {
            this.subNav = response;
            this.subNavActive = this.subNav[0].productId;
          } else {
            this.subNav = [];
            this.subNavActive = "";
          }
        })
        .catch(() => {
          this.subNav = [];
          this.subNavActive = "";
        });
    },
    mouseEnter(productId) {
      this.subnavShow = false;
      this.subNavActive = productId;
      setTimeout(() => {
        this.subnavShow = true;
      }, 300);
    },
    toPath(tabId) {
      if (tabId) {
        this.$router.push(`/products/${this.subNavActive}/${tabId}`);
      } else {
        this.navActive = "";
        return;
      }
    },
    disabled(tabId) {
      return (
        this.$route.params &&
        this.$route.params.id === String(this.subNavActive) &&
        this.activeTab === String(tabId).toLowerCase()
      );
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-nav {
  padding: 15px 0;
  color: #191818;
  .nav {
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    position: relative;
    .app-logo {
      cursor: pointer;
      margin-left: 5px;
      margin-top: 5px;
    }
    .primary-nav {
      // margin-left: 50px;
      li {
        cursor: pointer;
        display: inline-block;
        position: relative;
        padding: 0 15px;
        // font-weight: bold;
        font-size: 15px;
        &:after {
          content: "";
          // background: #fff;
          transition-duration: 0.4s;
          position: absolute;
          bottom: -10px;
          left: 20px;
          width: 33px;
          height: 3px;
        }
        &:hover {
          color: rgba(24, 24, 24, 0.5);
        }
      }
      li.active {
        &:after {
          background: #e00;
        }
      }
    }
  }
}
// 弹出菜单
.sub-nav {
  min-width: 300px;
  font-size: 15px;
  .sub-nav-row {
    background: rgba(255, 255, 255, 0.86);
  }
  .subnav-root {
    // padding: 15px 0;
    box-sizing: border-box;
    min-width: 100px;
    // height: 348px;
    background: rgba(255, 255, 255, 0.33);
    li {
      cursor: pointer;
      // border-bottom: 3px solid #ffffff;
      padding: 10px 10px;
      font-size: 16px;
      font-weight: bold;
    }
    li.active {
      background: rgba(218, 221, 224, 0.86);
      color: var(--color-primary);
      border-left: 2px solid var(--color-primary);
    }
    .subName {
      font-size: 12px;
      color: #9c9c9c;
      margin: 5px 0 0;
    }
  }
  .subnav-child {
    // background: rgba(218, 221, 224, 0.86);

    // border-left: 1px solid #ece9e9;
    padding: 15px;
    li {
      margin: 0px 15px 20px;
      &:hover {
        color: var(--color-primary);
      }
    }
  }
  .icon {
    margin-right: 10px;
  }
}
.home-dropdown {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
  -webkit-backdrop-filter: blur(8px);
  backdrop-filter: blur(8px);
  padding: 0;
}
.new-submenu {
  .icon {
    border: 1px solid #e9ecef !important;
    border-radius: 5px;
    margin-right: 15px;
    height: 22px;
  }
  .submenu-item {
    display: flex;
    margin: 8px 0;
    padding: 8px 16px;
    align-items: center;
    &:hover {
      background: #f3f4f6;
      .icon {
        background: #ffffff;
      }
      .subName {
        color: #004a71;
      }
    }
  }
  .new-badge {
    min-width: 38px;
    height: 18px;
    margin-left: auto;
    padding: 0 5px;
    border-radius: 4px;
    background: #ff674d;
    box-shadow: 0 2px 4px rgba(255, 103, 77, 0.24);
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 1px;
    text-align: center;
    box-sizing: border-box;
  }
  .subName {
    font-size: 12px;
    color: #3c4858;
    margin: 10px 0 0 0;
  }
}
</style>
